import React from 'react';

import '../../index.less';

import IbTypography from '../../../common/IbTypography';
import IbScrollSpy from '../../../common/IbScrollSpy';
import SchemaEditorExpandable from '../../../common/SchemaEditorExpandable';
import {
  BLOCK_CLASS_NAME,
  BLOCK_ITEM_CLASS_NAME,
  BLOCK_TITLE_CLASS_NAME,
  CONTENT_CLASS_NAME,
  ELMA365_TOOL_JSON_SCHEMA_SETTINGS_CLASS_NAME,
  MAIN_CLASS_NAME,
} from '../../const';
import { getTranslateFunc } from '../../../../utils/stringUtil';
import { CodeEditorSize } from '../../../common/CodeEditorExpandable/types';
import { UseValidationForm } from '../../../../utils/validationUtil';
import { ELMA365ToolForm } from '../../../../pages/toolkits/elma365/ToolPage';
import { CodeEditorStatus } from '../../../common/CodeEditor/types';

export interface IELMA365ToolJSONSchemaProps {
  toolId: string;
  inputSchema: string;
  outputSchema: string;
  validationForm: UseValidationForm<ELMA365ToolForm>;
  onChange: (inputSchema: string, outputSchema: string) => void;
}

const ELMA365ToolJSONSchema: React.FC<IELMA365ToolJSONSchemaProps> = ({
  toolId,
  inputSchema,
  outputSchema,
  validationForm,
  onChange,
}) => {
  const translate = getTranslateFunc('Toolkits: ELMA365: Tool: JSON Schema:');

  const onInputSchemaChange = (value = '') => {
    onChange(value, outputSchema);
    validationForm.onFieldChange('inputSchema', value);
  };

  const onInputSchemaBlur = () => {
    validationForm.onFieldBlur('inputSchema');
  };

  const onOutputSchemaChange = (value = '') => {
    onChange(inputSchema, value);
    validationForm.onFieldChange('outputSchema', value);
  };

  const onOutputSchemaBlur = () => {
    validationForm.onFieldBlur('outputSchema');
  };

  const renderJSONParamsBlock = () => {
    return (
      <div className={BLOCK_CLASS_NAME}>
        <IbTypography className={BLOCK_TITLE_CLASS_NAME}>
          <h4>{translate('JSON Params: Title')}</h4>
        </IbTypography>
        <div className={BLOCK_ITEM_CLASS_NAME}>
          <IbTypography.Paragraph strong type="secondary">
            {translate('JSON Params: Input schema: Title')}
          </IbTypography.Paragraph>
          <SchemaEditorExpandable
            readOnly
            codeFolder={`elma365/tool/${toolId}/input`}
            size={CodeEditorSize.XL}
            status={
              validationForm.getShowError(validationForm.validationState.inputSchema)
                ? CodeEditorStatus.Error
                : CodeEditorStatus.Default
            }
            value={inputSchema}
            onBlur={onInputSchemaBlur}
            onChange={onInputSchemaChange}
          />
          {validationForm.getShowError(validationForm.validationState.inputSchema) && (
            <IbTypography.Paragraph error type="descriptor">
              {validationForm.getErrorMessage(
                validationForm.validationState.inputSchema,
                translate('JSON Params: Input schema: Error')
              )}
            </IbTypography.Paragraph>
          )}
        </div>
        <div className={BLOCK_ITEM_CLASS_NAME}>
          <IbTypography.Paragraph strong type="secondary">
            {translate('JSON Params: Output schema: Title')}
          </IbTypography.Paragraph>
          <SchemaEditorExpandable
            readOnly
            codeFolder={`elma365/tool/${toolId}/output`}
            size={CodeEditorSize.XL}
            status={
              validationForm.getShowError(validationForm.validationState.outputSchema)
                ? CodeEditorStatus.Error
                : CodeEditorStatus.Default
            }
            value={outputSchema}
            onBlur={onOutputSchemaBlur}
            onChange={onOutputSchemaChange}
          />
          {validationForm.getShowError(validationForm.validationState.outputSchema) && (
            <IbTypography.Paragraph error type="descriptor">
              {validationForm.getErrorMessage(
                validationForm.validationState.outputSchema,
                translate('JSON Params: Output schema: Error')
              )}
            </IbTypography.Paragraph>
          )}
        </div>
      </div>
    );
  };

  const sections = [
    {
      id: 'json-params',
      title: translate('JSON Params: Title'),
      content: renderJSONParamsBlock(),
    },
  ];

  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={`${CONTENT_CLASS_NAME} ${ELMA365_TOOL_JSON_SCHEMA_SETTINGS_CLASS_NAME}`}>
        <IbScrollSpy displayNav sections={sections} />
      </div>
    </div>
  );
};

export default ELMA365ToolJSONSchema;
